/**
 * Konfigurácia push glue.
 *
 * `endpoint` = kanonický intake v jadre (`rshop/frontend` `PushTokensController`,
 * routa `/push-token`). Vstavaný fetch v `app-push.js` posiela `{token, provider}`
 * so `credentials: include` a hlavičkou `X-CSRF-Token` z `csrfToken` cookie —
 * presne to, čo `Csrf` komponenta jadra očakáva, takže netreba vlastný API klient.
 * Zvyšok (shop, locale, platforma, väzba na zákazníka alebo anonymné zariadenie)
 * si server doplní sám.
 *
 * Prompt na notifikácie sa vyžiada automaticky (default `autoPrompt`), ale **nie
 * hneď pri štarte** — čaká, kým je dorešený súhlas s cookies: na iOS až po ATT
 * dialógu, inde až po odpovedi na Cookiebot banner. Poradie zabezpečuje CMP
 * adaptér cez `window.__appConsentSettled` / event `app-consent-settled`, preto sa
 * `app-push.js` musí importovať PO ňom (viď `index.js`).
 *
 * Ručné vyžiadanie (opt-in tlačidlo, „až po objednávke") by bolo
 * `autoPrompt: false` + `window.AppPush.subscribe()` na príslušnom mieste.
 */
window.__appPushConfig = {
    endpoint: "/push-token",
    // Shop bez CMP (B2B) nemá na čo čakať, takže by si app-push.js prompt vyžiadal
    // hneď po APP_READY — čiže na login stránke ešte pred prihlásením. Server preto
    // pre neprihlásených v takom shope pošle `__appPushAutoPrompt = false` a prompt
    // príde až na prvej stránke po logine. Keď flag nie je (B2C), platí default.
    autoPrompt: window.__appPushAutoPrompt !== false,
};
